export const base = '/reports';
export const reports = `${base}`;
export const ordersReport = `${base}/orders`;
export const userDataReport = `${base}/users`;
export const quotesReport = `${base}/quotes`;
